import React from 'react';
import { Box } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import BounceDots from '@components/atoms/BounceDots';

const dotsAnimation = {
  animate: { opacity: [0, 1, 1, 0], transition: { duration: 1.5 } }
};

const SuspenseLoader = () => {
  return (
    <Box w="100%" bg="#7D55C7">
      <BounceDots
        as={motion.div}
        initial="dotsAnimate"
        variants={dotsAnimation}
      />
    </Box>
  );
};

export default SuspenseLoader;
